import React from 'react';
import ReactECharts from 'echarts-for-react';
import dayjs from 'dayjs';

const LineChart = ({ data, metric = 'kvart' }) => {
  // Format time and extract values
  const timeLabels = data.map(d => dayjs(d.createdon).format('HH:mm'));
  const values = data.map(d => d[metric]);

  const option = {
    title: {
      text: `Meter Data - ${metric.toUpperCase()}`,
      left: 'center',
    },
    tooltip: {
      trigger: 'axis',
    },
    xAxis: {
      type: 'category',
      data: timeLabels,
      axisLabel: { rotate: 45 }, // optional
    },
    yAxis: {
      type: 'value',
      name: metric.toUpperCase(),
    },
    series: [
      {
        name: metric.toUpperCase(),
        type: 'bar',
        data: values,
        itemStyle: {
          color: '#5470C6',
        },
      },
    ],
    grid: {
      left: '10%',
      right: '10%',
      bottom: '20%',
    },
  };

  return <ReactECharts option={option} style={{ height: 400 }} />;
};

export default LineChart;
